import React from 'react';
import '../../pages/FrontPage.css';

export default function PageBackground({ static: isStatic }) {
    return (
        <div className="FrontPage-bg PageBackground-desktop-only">
            <div
                className={'FrontPage-bg-doodles' + (isStatic ? ' FrontPage-bg-doodles--static' : '')}
                style={{backgroundImage: 'url(' + process.env.PUBLIC_URL + '/doodles.png)'}}
            ></div>
            <div className="FrontPage-bg-grid"></div>
        </div>
    );
}
